declare global {
  interface Window {
    fbq: (action: string, event: string) => void;
  }
}

export default function HeroSection() {
  const scrollToForm = () => {
    if (window.fbq) {
      window.fbq('track', 'Lead');
    }
    const formSection = document.getElementById('trial-form');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openLineContact = () => {
    if (window.fbq) {
      window.fbq('track', 'Contact');
    }
    const lineSection = document.getElementById('line-contact');
    if (lineSection) {
      lineSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative w-full h-screen min-h-[600px] md:min-h-screen overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        {/* Mobile Image */}
        <img
          src="https://static.readdy.ai/image/f1e8e8819fa7a9a02132dd8ff3c38992/b5a06fa411d26f069fa763ee19c46fdf.png"
          alt="DTM Studio with Singers"
          className="md:hidden w-full h-full object-cover object-center"
        />
        {/* Desktop Image */}
        <img
          src="https://static.readdy.ai/image/f1e8e8819fa7a9a02132dd8ff3c38992/d22aebb7a572524e3fef60bd83d22450.png"
          alt="DTM Studio with Singers"
          className="hidden md:block w-full h-full object-cover object-left"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/30"></div>
      </div>

      {/* Character Credit - Bottom Right */}
      <div className="absolute bottom-4 right-4 md:bottom-6 md:right-6 z-10">
        <p className="text-white text-xs md:text-sm font-medium drop-shadow-lg font-noto tracking-wide">
          イメージキャラクター しずくちゃん
        </p>
      </div>

      {/* Main Content - Positioned to bottom-left */}
      <div className="absolute bottom-16 md:bottom-32 left-4 md:left-12 z-10 px-2 md:px-6">
        {/* Color Matte Banners with Text */}
        <div className="flex flex-col gap-2 md:gap-3 mb-6 md:mb-8">
          {/* Main Copy - White Matte with Transparency */}
          <div className="bg-white/85 px-4 py-3 md:px-6 md:py-6 shadow-2xl inline-block w-fit backdrop-blur-sm border-l-8 border-orange-500">
            <h1 className="text-2xl md:text-5xl lg:text-6xl font-black text-orange-500 text-left leading-tight font-zen tracking-tight">
              <span className="md:hidden">歌ってみたい。<br />でも、自信がない。</span>
              <span className="hidden md:inline whitespace-nowrap">歌ってみたい。でも、自信がない。</span>
            </h1>
          </div>
          
          {/* Sub Copy - White Matte with Transparency */}
          <div className="bg-white/85 px-4 py-2 md:px-6 md:py-4 shadow-2xl inline-block w-fit backdrop-blur-sm">
            <p className="text-sm md:text-xl lg:text-2xl font-bold text-gray-800 text-left leading-relaxed font-noto">
              <span className="md:hidden">
                録音しても「これでいいの?」<br />
                投稿したいけど、やり方がわからない<br />
                下手だったらどうしよう、って思ってる人へ
              </span>
              <span className="hidden md:inline">
                録音しても「これでいいの?」<br />
                投稿したいけど、やり方がわからない<br />
                下手だったらどうしよう、って思ってる人へ
              </span>
            </p>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col md:flex-row gap-3 md:gap-6 items-start">
          <button
            onClick={scrollToForm}
            className="whitespace-nowrap group bg-orange-500 hover:bg-orange-600 text-white font-bold text-base md:text-xl px-6 py-3 md:px-12 md:py-6 rounded-lg shadow-xl transition-all duration-300 cursor-pointer flex items-center gap-2 md:gap-3 font-rounded tracking-wide"
          >
            無料体験レッスンを予約
            <i className="ri-arrow-right-s-line text-xl md:text-2xl"></i>
          </button>

          <button
            onClick={openLineContact}
            className="whitespace-nowrap group bg-green-500 hover:bg-green-600 text-white font-bold text-base md:text-xl px-6 py-3 md:px-12 md:py-6 rounded-lg shadow-xl transition-all duration-300 cursor-pointer flex items-center gap-2 md:gap-3 font-rounded tracking-wide"
          >
            LINEで気軽に相談
            <i className="ri-arrow-right-s-line text-xl md:text-2xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
